export enum ItemNames {
    UserCustomPropertiesItem = 'UserCustomPropertiesItem',
}
